import React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import InputText from 'FormInputs/InputText/InputText';
import AppStorage from 'Storage/Storage';
import { AddressModel } from 'FormInputs/InputAddress/InputAddress';
import Labels from '../../../enums/Labels';

type Props = {
  addressModel: AddressModel;
};

class InternationalZipCodeHouseNumberInputWefox extends React.Component<Props> {
  private readonly storage: AppStorage;

  constructor(props: Props) {
    super(props);

    this.storage = AppStorage.getInstance();
  }

  render(): React.ReactElement {
    const {
      addressModel,
    } = this.props;

    return (
      <div className="international-wefox zip-code-house-number">
        <label className="zip-code-house-number-label">
          <Field name={addressModel.zipCodeInt}>
            {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
              <InputText
                labelWrapperClass="form-input"
                label={Labels.PERSONAL_DETAILS_ZIP_CODE}
                placeholder={Labels.PERSONAL_DETAILS_ZIP_CODE}
                input={input}
                meta={meta}
                isRequired={true}
              />
            )}
          </Field>
        </label>
        <label className="zip-code-house-number-label">
          <Field name={addressModel.houseNumber}>
            {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
              <InputText
                labelWrapperClass="form-input"
                label={Labels.PERSONAL_DETAILS_HOUSE_NUMBER}
                placeholder={Labels.PERSONAL_DETAILS_HOUSE_NUMBER}
                input={input}
                meta={meta}
                isRequired={true}
              />
            )}
          </Field>
        </label>
        <label className="zip-code-house-number-label">
          <Field name={addressModel.houseLetter}>
            {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
              <InputText
                labelWrapperClass="form-input"
                label={Labels.PERSONAL_DETAILS_HOUSE_LETTER}
                placeholder={Labels.PERSONAL_DETAILS_HOUSE_LETTER}
                input={input}
                meta={meta}
              />
            )}
          </Field>
        </label>
      </div>
    );
  }
}
export default InternationalZipCodeHouseNumberInputWefox;
